import { DatePicker, Input, Select, Textarea } from '@chilecompra/react-kit/components'
import { addYears, endOfYear, startOfYear, subYears } from 'date-fns'
import PropTypes from 'prop-types'

import { Container, Item } from '../../Cfmp.styles'
import { inputShape, selectFieldShape } from './CfmpForm.propTypes'

/**
 * The CfmpFormAdministrativeAct component.
 */
export const CfmpFormAdministrativeAct = ({
  administrativeActDate,
  administrativeActName,
  administrativeActNumber,
  administrativeActType,
  administrativeActTypeDetail,
  isDisabled = false,
  isSourcesLoading = false,
  procedureType,
  procedureTypeDetail
}) => (
  <Container direction="column" spacing={2}>
    <Item size={{ lg: 6, xs: 12 }}>
      <DatePicker
        disabled={isDisabled}
        error={administrativeActDate.error}
        format="dd/MM/yyyy"
        label="Fecha de acto administrativo aprobatorio"
        loading={isSourcesLoading}
        localeText={{
          fieldYearPlaceholder: params => 'A'.repeat(params.digitAmount)
        }}
        maxDate={endOfYear(addYears(new Date(), 5))}
        minDate={startOfYear(subYears(new Date(), 25))}
        onChange={administrativeActDate.onChange}
        value={administrativeActDate.value}
      />
    </Item>

    <Item container size={12} spacing={2}>
      <Item size={{ lg: 6, xs: 12 }}>
        <Select
          disabled={Boolean(administrativeActType.source.error) || isDisabled}
          error={administrativeActType.errorText}
          label="Tipo de acto administrativo"
          loading={isSourcesLoading}
          onChange={administrativeActType.input.onChange}
          options={administrativeActType.source.data}
          placeholder={
            administrativeActType.source.error
              ? 'Sin tipo de acto administrativo disponible'
              : 'Seleccione un tipo de acto administrativo...'
          }
          value={administrativeActType.input.value}
        />
      </Item>

      {administrativeActType.isOtherSelected && (
        <Item size={{ lg: 6, xs: 12 }}>
          <Input
            disabled={isDisabled}
            error={administrativeActTypeDetail.error}
            label="Especifica el tipo de acto administrativo"
            onChange={administrativeActTypeDetail.onChange}
            value={administrativeActTypeDetail.value}
          />
        </Item>
      )}
    </Item>

    <Item container size={12} spacing={2}>
      <Item size={{ lg: 6, xs: 12 }}>
        <Input
          disabled={isDisabled}
          error={administrativeActNumber.error}
          label="Número del acto administrativo"
          loading={isSourcesLoading}
          maxLength={20}
          onChange={administrativeActNumber.onChange}
          value={administrativeActNumber.value}
        />
      </Item>

      <Item size={{ lg: 6, xs: 12 }}>
        <Select
          disabled={Boolean(procedureType.source.error) || isDisabled}
          error={procedureType.errorText}
          label="Tipo de procedimiento de compra utilizado"
          loading={isSourcesLoading}
          onChange={procedureType.input.onChange}
          options={procedureType.source.data}
          placeholder={
            procedureType.source.error
              ? 'Sin tipo de procedimiento disponible'
              : 'Seleccione un tipo de procedimiento...'
          }
          value={procedureType.input.value}
        />
      </Item>

      {procedureType.isOtherSelected && (
        <Item size={{ lg: 6, xs: 12 }}>
          <Input
            disabled={isDisabled}
            error={procedureTypeDetail.error}
            label="Especifica el tipo de procedimiento de compra utilizado"
            onChange={procedureTypeDetail.onChange}
            value={procedureTypeDetail.value}
          />
        </Item>
      )}
    </Item>

    <Item size={12}>
      <Textarea
        disabled={isDisabled}
        error={administrativeActName.error}
        label="Denominación del acto administrativo aprobatorio"
        loading={isSourcesLoading}
        maxCount={200}
        maxLength={200}
        minRows={8}
        onChange={administrativeActName.onChange}
        value={administrativeActName.value}
      />
    </Item>
  </Container>
)

CfmpFormAdministrativeAct.propTypes = {
  administrativeActDate: inputShape.isRequired,
  administrativeActName: inputShape.isRequired,
  administrativeActNumber: inputShape.isRequired,
  administrativeActType: selectFieldShape.isRequired,
  administrativeActTypeDetail: inputShape.isRequired,
  isDisabled: PropTypes.bool,
  isSourcesLoading: PropTypes.bool,
  procedureType: selectFieldShape.isRequired,
  procedureTypeDetail: inputShape.isRequired
}
